export const GET_VOTES = 'GET_VOTES'
export const TYPE_TICKET = 'ticket'
export const TYPE_ADD_VOTE = 'addvote'
export const TYPE_STREAM = 'stream'
export const PATH_STREAM = 'stream'
